<template>
    <div id="app">
        <header v-if="showHeader">
            <div class="header-inner-wrapper" >
                <div class="logo mv2">
                    <Logo />
                </div>
                <div>
                  <p class="regular mv2">We brought watchmaking back to the USA. Each watch in the collection documents American craftsmanship and ingenuity. For this gallery, we worked with photographer Bryan Schutmaat, to document the diverse American landscape and culture that inspires us.</p>
                  <a class="animated-button learn-more-btn" href="https://www.timex.com/browse/collections/american-documents/">Learn More</a>
                </div>
            </div>
        </header>
        <div class="wrapper" v-bind:class="{ 'wrapper-no-header': !showHeader }">
            <nav>
                <div class="nav-list-wrapper">
                    <ul class="nav-list">
                        <li><router-link 
                                :class="{ 'active' : path == '/' }"
                                class="nav-item"
                                to="/">ALL DOCUMENTS</router-link></li>
                        <li><router-link
                                :class="{ 'active' : path == '/desert-west' }"
                                class="nav-item"
                                to="/desert-west">DESERT WEST</router-link></li>
                        <li><router-link 
                                :class="{ 'active' : path == '/north-east' }"
                                class="nav-item" 
                                to="/north-east">NORTH EAST</router-link></li>
                        <li><router-link 
                        :class="{ 'active' : path == '/mountain-west' }"
                                class="nav-item"
                                to="/mountain-west">MOUNTAIN WEST</router-link></li>
                    </ul>
                </div>
            </nav>
            <main class="contain">
              <transition name="list">
                <router-view/>
              </transition>
            </main>
        </div>
  </div>
</template>

<script>

import Logo from './components/Logo'
import Router from 'vue-router'

import store from './store'

export default {
  components: {Logo},
  name: 'app',
  data() {
    return {
      isHome: this.$route.path == "/" ? true : false,
      myTest: this.$route.path == "/north" ? true : false,
      path: this.$route.path
    }
  },
    watch: {
        $route (to, from) {
            this.isHome = this.$route.path == "/" ? true : false,
            this.path = this.$route.path
        }
    },
    computed: {
        showHeader: function () {
            if(this.$route.path == '/' || this.$route.path == '/north') {
                return true;
            } else {
                return false;
            }

        }
    },
    methods: {
        // lazyloadinit() {
        //     setTimeout( () => window.dispatchEvent(new Event('lazy-load')),300)
        // }
    },
    mounted() {
        // this.lazyloadinit();
    }
}
</script>

<style lang="scss">

body, html {
  width: 100%;
  height: 100%;
  position: relative;
  font-family: 'Gotham Narrow Book';
}

@font-face {
  font-family: 'Gotham Narrow Book';
  src: url('assets/GothamNarrow-Book.woff') format('woff2');
  unicode-range: U+0020-007F; /* The bare minimum for the English Language */
}

@font-face {
  font-family: 'Gotham Narrow Medium';
  src: url('assets/GothamNarrow-Medium.woff') format('woff2');
  unicode-range: U+0020-007F; /* The bare minimum for the English Language */
}

@font-face {
  font-family: 'Gotham Narrow Bold';
  src: url('assets/GothamNarrow-Bold.woff') format('woff2');
  unicode-range: U+0020-007F; /* The bare minimum for the English Language */
}



header {
  position: fixed;
  top: 0;
  width: 100%;
  background: #111;
  color: white;
  text-align: center;
  padding: 2rem;
  z-index: 0;
}

.no-text { top: 240px !important; }

.header-inner-wrapper {
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
  @media screen and (min-width: 769px){
      max-width: 720px;
  }
}
.header-inner-wrapper p, .header-inner-wrapper a {
  color: #cccccc;
}

.learn-more-btn {
    display: inline-block;
    padding: 5px 45px;
    border: solid 1px #ccc;
}

.nav-item {
  padding-top: 10px;
  font-weight: 400;
}
.nav-item.active {
    font-family: 'Gotham Narrow Bold';
}

.nav-item:before {
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 2px;
  background: #000;
  -webkit-transform: scaleX(0);
          transform: scaleX(0);
}

.nav-item:hover:before {
  -webkit-transform: scaleX(1);
          transform: scaleX(1);
}

a:before, a:after {
  content: '';
  position: absolute;
  transition: -webkit-transform .4s ease;
  transition: transform .4s ease;
  transition: transform .4s ease, -webkit-transform .4s ease;
}

a {
  position: relative;
  color: inherit;
  text-decoration: none;
  line-height: 24px;
}

.wrapper {
  float: left;
  background: white;
  width: 100%;
  position: relative;
  top: 450px;
  z-index: 10;
}

@media screen and (min-width: 525px) {
  .wrapper { top: 410px; }
}

@media screen and (min-width: 600px) {
  .wrapper { top: 370px; }
}

.wrapper-no-header {
  top: 0;
}

nav {
  width: 100%;
  background: white;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-list {
  width: 100%;
  max-width: 700px;
  min-width: 700px;
  margin: 0 auto;
  list-style: none;
  padding: 0;
}
.nav-list li {
  float: left;
  padding: 10px;
}

.nav-list-wrapper {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 10px;
    box-shadow: -27px 0px 35px -19px rgba(0,0,0,.1) inset;
    @media screen and (min-width: 500px) {
        box-shadow: unset;
    }
}

@supports (display: flex) {
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
}

.logo {
  display: inline-block;
  width: 100%;
  max-width: 240px;
  margin: 0 auto;
}

.contain {
    display: block;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
}

.list-enter-active,
.list-leave-active {
  transition: 450ms ease-out;
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transition: 450ms ease-out;
  transform: translateY(20px) ;
}

.list-enter-to {
  opacity: 1;
  transition: 450ms ease-out;
  transition-delay: 450ms;
}

.list-leave-to {
  opacity: 0;
}
main {
    min-height: 700px;
}
body {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue